$(document).on('submit', '[data-item-set-free-item-form]', function (event) {
  event.preventDefault();
  event.stopPropagation();
  const form = $(this);
  const button = form.find('.add-to-cart__button');
  const url = form.attr('action');

  button.find('.icon-cart').hide();
  button.find('.loader').fadeIn(200);

  $.ajax({
    type: 'POST',
    url,
    headers: {
      'X-CSRFToken': form.find('input[name="csrfmiddlewaretoken"]').val(),
    },
  })
    .done(() => {
      button.find('.loader').hide();
      button.find('.icon-check').fadeIn(200);
      setTimeout(() => {
        button.find('.icon-check').hide();
        button.find('.icon-cart').fadeIn(200);
      }, 1000);
    });
});
